import React, {useContext}  from 'react';
import {UserContext} from './../../contexts/UserContext';
import styled from 'styled-components';

import Container from './../../common/components/Container';
import Icon from './../../common/components/Icon';
import UserMenu from '../../common/components/UserMenu';


const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  background: #ffffff;
  height: 80px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;

const Content = styled.div.withConfig({displayName:'-Content'})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
`;

const Left = styled.div.withConfig({displayName:'-Left'})`
`;

const Right = styled.div.withConfig({displayName:'-Right'})`
  display: flex;
  align-items: center;
  height: 80px;
`;


// const MenuSpacer = styled.div.withConfig({displayName:'-MenuSpacer'})`
//   padding-bottom: 12px;
//   border-bottom: 1px solid #70707033;
//   margin-bottom: 7px;
// `;



const Header = ({callbackTogglerMenu}) => {
  const {user} = useContext(UserContext);

  // const [user, setuser] = useState(null);
  //
  // useEffect(() => {
  //   AuthService.get().then((response) => {
  //     if(response.success){
  //       setuser(response.data);
  //     }else{
  //       console.log(response.error);
  //     }
  //   });
  // }, [setuser]);

  return (
    <Wrapper>
      <Container size="fluid">
        <Content>
          <Left>
            <div onClick={callbackTogglerMenu}>
              <Icon name={"menu"} color={"#303030"} size="30px"/>
            </div>
          </Left>
          <Right>
            {user ?
              <UserMenu />
            : null }
          </Right>
        </Content>
      </Container>
    </Wrapper>
  )
}

export default Header;
